
import { locale } from './globals.js';

class PropertyMap {
  constructor (el) {
    if(!el) return false;
    this.el = el
    $(this.el).mapplic({
      source: `/assets/data/map-data-${locale.lang}.json`,
      height: 480,
      minimap: false,
      sidebar: false,
      hovertip: true,
      maxscale: 3
    });
    
  }

  
}
export default function () {
  new PropertyMap(document.querySelector('[data-property-map]'));
}
